module.exports = __webpack_public_path__ + "img/ic_file-info-missing.ea5849bf.svg";